import { createSlice } from "@reduxjs/toolkit";

const loadFromLocalStorage = () => {
  const savedState = localStorage.getItem("policyState");

  return savedState ? JSON.parse(savedState) : null;
};

const initialState = loadFromLocalStorage() || {
  policies: null,
};

const saveToLocalStorage = (state) => {
  localStorage.setItem("policyState", JSON.stringify(state));
};

export const policySlice = createSlice({
  name: "policy",
  initialState,
  reducers: {
    setPolicies: (state, action) => {
      state.policies = action.payload;
      saveToLocalStorage(state);
    },
  },
});

export const getPolicies = (state) => state.policy.policies;
export const { setPolicies } = policySlice.actions;

export default policySlice.reducer;
